import { Checkbox } from '@mui/material';
import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { NodeSyncPlanApiModel } from '../../../../types/models/sync/node-sync-plan.model';
import { SyncPlan } from './SyncPlan';

type Props = { plan: NodeSyncPlanApiModel; onPlanChanged?: (newPlan: NodeSyncPlanApiModel) => void };

export const NodeSyncPlan = ({ plan, onPlanChanged }: Props) => {
  const columns: ColDef<
    | NodeSyncPlanApiModel['create'][number]
    | NodeSyncPlanApiModel['update'][number]
    | NodeSyncPlanApiModel['delete'][number]
  >[] = [
    { field: 'name', filter: true },
    { field: 'parent.name', headerName: 'Category', filter: true },
    { field: 'description', filter: true },
    {
      field: 'includeInSurface',
      cellRenderer: ({ node }: CustomCellRendererProps<NodeSyncPlanApiModel['create'][number]>) =>
        node.data?.includeInSurface !== undefined ? <Checkbox checked={node.data?.includeInSurface} disabled /> : null,
    },
    { field: 'featureType.name', headerName: 'Feature Type', filter: true },
    { field: 'pointLayer.name', headerName: 'Point Layer', filter: true },
    { field: 'breaklineLayer.name', headerName: 'Linework Layer', filter: true },
    { field: 'symbol.name', headerName: 'Symbol', filter: true },
    {
      field: 'domains',
      filter: true,
      valueGetter: ({
        data,
      }: ValueGetterParams<NodeSyncPlanApiModel['create'][number] | NodeSyncPlanApiModel['update'][number]>) =>
        data?.domains?.map(({ name }) => name).join(', '),
    },
  ];

  return <SyncPlan plan={plan} columns={columns} onPlanChanged={onPlanChanged} />;
};
